import type { ColumnsType } from 'antd/es/table';

import type { RecordDetail } from './types';

export const COLUMNS: ColumnsType<RecordDetail> = [
  {
    title: '路線',
    dataIndex: 'route',
  },
  {
    title: '設備',
    dataIndex: 'equipment',
  },
  {
    title: '巡檢人員',
    dataIndex: 'inspector',
  },
  {
    title: '狀態',
    dataIndex: 'status',
  },
  {
    title: '預計巡檢時間',
    dataIndex: 'estimatedTime',
  },
  {
    title: '實際巡檢時間',
    dataIndex: 'finishedTime',
  },
  {
    title: '附件',
    dataIndex: 'attachment',
  },
  {
    title: '備註',
    dataIndex: 'note',
  },
];
